import { monicaMediaArray } from './monicaMedia'
import { monicaBio } from './monicaBios'
import { rachelProfileReviewHinge, rossProfileReviewBumble, joeyProfileReviewTinder } from './monicaProfileReviews'

export const monicaDatingProfileHinge = {
  _id: 'monicaDatingProfileHingeId',
  userId: 'monicaUserId',
  email: 'monica@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: monicaMediaArray[10]._id,
      mediaItemURL: monicaMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[10].type,
      caption: monicaMediaArray[10].captions[0],
      subcaption: monicaMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[4]._id,
      mediaItemURL: monicaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[4].type,
      caption: monicaMediaArray[4].captions[0],
      subcaption: monicaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[0]._id,
      mediaItemURL: monicaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[0].type,
      caption: monicaMediaArray[0].captions[0],
      subcaption: monicaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[11]._id,
      mediaItemURL: monicaMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[11].type,
      caption: monicaMediaArray[11].captions[0],
      subcaption: monicaMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[7]._id,
      mediaItemURL: monicaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[7].type,
      caption: monicaMediaArray[7].captions[0],
      subcaption: monicaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[5]._id,
      mediaItemURL: monicaMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[5].type,
      caption: monicaMediaArray[5].captions[0],
      subcaption: monicaMediaArray[5].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: monicaBio._id,
    vitalInfo: { ...monicaBio.vitalInfo },
    prompts: [
      { ...monicaBio.prompts[0] },
      { ...monicaBio.prompts[1] },
      { ...monicaBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...rachelProfileReviewHinge }
  ],
  mediaItems: [ ...monicaMediaArray ],
  bioItems: { ...monicaBio },
}

export const monicaDatingProfileBumble = {
  _id: 'monicaDatingProfileBumbleId',
  userId: 'monicaUserId',
  email: 'monica@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: monicaMediaArray[10]._id,
      mediaItemURL: monicaMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[10].type,
      caption: monicaMediaArray[10].captions[0],
      subcaption: monicaMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[4]._id,
      mediaItemURL: monicaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[4].type,
      caption: monicaMediaArray[4].captions[0],
      subcaption: monicaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[0]._id,
      mediaItemURL: monicaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[0].type,
      caption: monicaMediaArray[0].captions[0],
      subcaption: monicaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[11]._id,
      mediaItemURL: monicaMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[11].type,
      caption: monicaMediaArray[11].captions[0],
      subcaption: monicaMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[7]._id,
      mediaItemURL: monicaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[7].type,
      caption: monicaMediaArray[7].captions[0],
      subcaption: monicaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[5]._id,
      mediaItemURL: monicaMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[5].type,
      caption: monicaMediaArray[5].captions[0],
      subcaption: monicaMediaArray[5].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: monicaBio._id,
    vitalInfo: { ...monicaBio.vitalInfo },
    prompts: [
      { ...monicaBio.prompts[0] },
      { ...monicaBio.prompts[1] },
      { ...monicaBio.prompts[2] }
    ],
    aboutMe: monicaBio.aboutMe[0],
    hobbies: [monicaBio.hobbies[0], monicaBio.hobbies[1], monicaBio.hobbies[2], monicaBio.hobbies[3], monicaBio.hobbies[4] ],
  },
  profileReviews: [
    { ...rossProfileReviewBumble }
  ],
  mediaItems: [ ...monicaMediaArray ],
  bioItems: { ...monicaBio },
}

export const monicaDatingProfileTinder = {
  _id: 'monicaDatingProfileTinderId',
  userId: 'monicaUserId',
  email: 'monica@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: monicaMediaArray[10]._id,
      mediaItemURL: monicaMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[10].type,
      caption: monicaMediaArray[10].captions[0],
      subcaption: monicaMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[4]._id,
      mediaItemURL: monicaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[4].type,
      caption: monicaMediaArray[4].captions[0],
      subcaption: monicaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[0]._id,
      mediaItemURL: monicaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[0].type,
      caption: monicaMediaArray[0].captions[0],
      subcaption: monicaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[11]._id,
      mediaItemURL: monicaMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[11].type,
      caption: monicaMediaArray[11].captions[0],
      subcaption: monicaMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[7]._id,
      mediaItemURL: monicaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[7].type,
      caption: monicaMediaArray[7].captions[0],
      subcaption: monicaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[5]._id,
      mediaItemURL: monicaMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[5].type,
      caption: monicaMediaArray[5].captions[0],
      subcaption: monicaMediaArray[5].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: monicaBio._id,
    vitalInfo: { ...monicaBio.vitalInfo },
    prompts: [
      { ...monicaBio.prompts[0] },
      { ...monicaBio.prompts[1] },
      { ...monicaBio.prompts[2] }
    ],
    aboutMe: monicaBio.aboutMe[0],
    hobbies: [monicaBio.hobbies[0], monicaBio.hobbies[1], monicaBio.hobbies[2], monicaBio.hobbies[3], monicaBio.hobbies[4] ],
  },
  profileReviews: [
    { ...joeyProfileReviewTinder }
  ],
  mediaItems: [ ...monicaMediaArray ],
  bioItems: { ...monicaBio },
}